import { render, staticRenderFns } from "./StorageRoomModal.vue?vue&type=template&id=6469c4e4"
import script from "./StorageRoomModal.vue?vue&type=script&lang=js"
export * from "./StorageRoomModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports